/**
 * Utilities for collecting other objects' rotation angles for use in rotation snap computation.
 */

/**
 * Returns the rotation angles (in degrees) of all non-excluded, non-hidden shapes and text boxes.
 * Used to snap a rotating object to the angle of another object on the canvas.
 */
export function getOtherObjectRotations(
  excludeIds: Set<string>,
  shapes: ReadonlyArray<{ id: string; hidden?: boolean; rotation?: number }>,
  textBoxes: ReadonlyArray<{ id: string; hidden?: boolean; rotation?: number }>
): number[] {
  const angles: number[] = []

  for (const s of shapes) {
    if (!excludeIds.has(s.id) && !s.hidden && s.rotation != null) {
      angles.push(s.rotation)
    }
  }

  for (const t of textBoxes) {
    if (!excludeIds.has(t.id) && !t.hidden && t.rotation != null) {
      angles.push(t.rotation)
    }
  }

  return angles
}
